(() => {
  const root = document.querySelector('[data-ul-global-reviews]');
  if (!root) return;
  const grid = root.querySelector('[data-review-grid]');
  const sort = root.querySelector('[data-review-sort]');
  const sentinel = root.querySelector('[data-review-sentinel]');
  const status = root.querySelector('[data-review-status]');
  let page = 1;
  let total = 0;
  let loading = false;
  let failed = false;

  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const stars = (rating) => '★★★★★'.slice(0, rating) + '☆☆☆☆☆'.slice(rating);
  const date = (value) => new Intl.DateTimeFormat('es-MX', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(value));
  const author = (value) => {
    const name = String(value || '').trim();
    return /\S+@\S+\.\S+/.test(name) ? 'Cliente verificado' : (name || 'Cliente');
  };
  const card = (review) => {
    const article = document.createElement('article');
    article.className = 'ul-reviews-page__card';
    const media = Array.isArray(review.media) && review.media[0]
      ? `<img src="${esc(review.media[0])}" alt="Foto compartida en la reseña" loading="lazy">`
      : '';
    const product = review.productHandle
      ? `<a href="/products/${encodeURIComponent(review.productHandle)}">${esc(review.productTitle || 'Ver producto')}</a>`
      : `<span>${esc(review.productTitle || '')}</span>`;
    article.innerHTML = `${media}<div class="ul-reviews-page__card-body"><div class="ul-reviews-page__card-top"><span class="ul-reviews-page__stars">${stars(Number(review.rating) || 0)}</span><time datetime="${esc(review.createdAt)}">${date(review.createdAt)}</time></div>${review.title ? `<h2>${esc(review.title)}</h2>` : ''}<p>${esc(review.body || '')}</p><footer><strong>${esc(author(review.authorName))}</strong>${review.verifiedPurchase ? '<em>COMPRA VERIFICADA</em>' : ''}${product}</footer></div>`;
    return article;
  };

  async function load(reset = false) {
    if (loading) return;
    if (reset) { page = 1; grid.replaceChildren(); failed = false; }
    loading = true;
    status.hidden = true;
    try {
      const response = await fetch(`${root.dataset.endpoint}?page=${page}&per_page=12&sort=${sort.value}`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      total = data.pagination.total;
      root.querySelector('[data-review-score]').textContent = Number(data.stats.averageRating).toFixed(1);
      root.querySelector('[data-review-stars]').textContent = stars(Math.round(data.stats.averageRating));
      root.querySelector('[data-review-count]').textContent = `${total} RESEÑAS VERIFICADAS`;
      data.reviews.forEach((review) => grid.appendChild(card(review)));
    } catch (error) {
      status.textContent = 'No fue posible cargar las reseñas. Intenta de nuevo.';
      status.hidden = false;
      failed = true;
    } finally {
      loading = false;
    }
  }

  const loadNext = async () => {
    if (loading || failed || !total || grid.children.length >= total) return;
    page += 1;
    await load(false);
  };

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) loadNext();
  }, { rootMargin: '600px 0px' });
  observer.observe(sentinel);

  sort.addEventListener('change', () => load(true));
  load(true);
})();
